export const UPDATE_TEAMS = 'UPDATE_TEAMS';

export const updateTeams = teams => {
  return {
    type: UPDATE_TEAMS,
    teams,
  };
};
